import React, { KeyboardEvent, ReactElement, useState } from 'react';
import isEqual from 'lodash.isequal';
import { useDeviceType } from 'b2b-apps/shop/common/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const deviceType = useDeviceType();
    const defaultOnKeyDown = () => (event: KeyboardEvent) => {
      event.preventDefault();
    };

    const [onKeyDown, setOnKeyDown] = useState(defaultOnKeyDown);

    const injectedProps: InjectedProps = {
      deviceType,
      onKeyDown,
      setOnKeyDown,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};
